import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class AreaStaticChip extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
        styleName: PropTypes.string,
    };

    render() {
        const { content, styleName } = this.props;

        if (content) {
            return <div className={`${styles.box} ${styleName || ''}`} dangerouslySetInnerHTML={{ __html: content }} />;
        }

        return <div className={styleName} />;
    }
}

export default errorBoundary(AreaStaticChip);
